import ServiceCRUD from '../../../services/ServiceCRUDNEWCHANNEL';
import { apiChatTS } from '../../../http';

class IgnoredWordsService extends ServiceCRUD {
  constructor() {
    super('ignoredwords');
  }

  createIgnoredWords(data) {
    return apiChatTS.post(`${this.path}`, data, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    });
  }

  getAllFilter(page = 1, search = '') {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('limit', '10');

    if (search && search.trim() !== '') {
      params.append('search', search.trim());
    }

    return apiChatTS.get(`${this.path}?${params.toString()}`);
  }

  getById(id) {
    console.log(`[IgnoredWordsService] Buscando por ID: ${id}`);
    return apiChatTS.get(`${this.path}/${id}`);
  }

  update(id, data) {
    return apiChatTS.patch(`${this.path}/${id}`, data, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    });
  }

  delete(id) {
    return apiChatTS.delete(`${this.path}/${id}`);
  }
}

export default new IgnoredWordsService();
